document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  const overlapEnabled = header.dataset.check === 'true';
  const stickyAfter = 100;

  const updateHeader = () => {
    const isScrolled = window.scrollY > stickyAfter;

    header.classList.toggle('sticky', isScrolled);

    header.classList.toggle(
      'overlap-menu',
      overlapEnabled && !isScrolled
    );
  };

  updateHeader();

  window.addEventListener('scroll', updateHeader, {
    passive: true
  });
});